/* eslint-disable class-methods-use-this */
/* eslint-disable no-useless-constructor */
/* eslint-disable no-undef */
export default class extends Phaser.Scene {
  constructor() {
    super();
  }

  init(data) {
    this.gameSize = data;
  }

  preload() {
    this.load.setPath('https://s3.amazonaws.com/images.growmindgrow/phaser-assets/images/AboutButton');
    this.load.image('Arrow_Left', 'Arrow_Left.png');
    this.load.image('Arrow_Right', 'Arrow_Right.png');
    this.load.image('Button_About', 'Button_About.png');
    this.load.image('Button_Ok', 'Button_Ok.png');
    this.load.image('Button_Pause', 'Button_Pause.png');
    this.load.image('Button_Sound', 'Button_Sound.png');
    this.load.image('Button_X', 'Button_X.png');
    this.load.image('Frame', 'Frame.png');

    return this;
  }

  create() {
    this.aboutButton = this.createButton(this.gameSize.width - 30, 30, 'Button_About', this.showInfo).setOrigin(1, 0);
    this.createInfo();
    this.hideInfo();
  }

  createButton(x, y, sprite, callback) {
    return this.add
      .image(x, y, sprite)
      .setInteractive()
      .on('pointerup', callback, this);
  }

  createInfo() {
    const w = this.gameSize.width;
    const h = this.gameSize.height;

    this.infoElements = [];

    const frame = this.add.image(w / 2, h / 2, 'Frame');

    this.infoElements.push(
      frame,
      this.createButton(frame.x + frame.displayWidth / 2 + 10, frame.y, 'Arrow_Right', this.previousPage),
      this.createButton(frame.x - frame.displayWidth / 2 - 10, frame.y, 'Arrow_Left', this.nextPage),
      this.createButton(frame.x, frame.y + frame.displayHeight / 2 - 10, 'Button_Ok', this.hideInfo),
      this.createButton(frame.x, frame.y - frame.displayHeight / 2 + 10, 'Button_Sound', this.handleSound),
      this.createButton(
        frame.x + frame.displayWidth / 2 - 20,
        frame.y - frame.displayHeight / 2 + 20,
        'Button_X',
        this.hideInfo,
      ),
    );
  }

  hideInfo() {
    this.aboutButton.setVisible(true);
    this.infoElements.forEach(e => e.setVisible(false));
  }

  showInfo() {
    this.aboutButton.setVisible(false);
    this.infoElements.forEach(e => e.setVisible(true));
  }

  nextPage() {}

  previousPage() {}

  handleSound() {}
}
